import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpService} from "../../services/http/http.service";
import {VisitorFormDto} from "./contracts/visitor-form.dto";

@Injectable({providedIn: 'root'})
export class VisitorsService {
  private base = environment.url + '/api/visitor/';

  constructor(private http: HttpService) {
  }

  submit(form: VisitorFormDto) {
    return this.http.post(this.base + 'submit', form);
  }

}
